import React, { useState } from "react";
import { navigate, withPrefix } from "gatsby";
import axios from "axios";
import Main from "../Layout/Main";
import Section from "../Layout/Section/Section";
import InnerContainer from "../Layout/InnerContainer/InnerContainer";
import { handleLogin, setUser } from "../../helpers/loginHelper";

import "./login.scss";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const authURL = "/.netlify/functions/cmtPartnerAuth";

  const handlePasswordChange = (e) => {
    e.persist();
    setPassword(e.target.value);
  };

  const handleNameChange = (e) => {
    e.persist();
    setUsername(e.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (username !== "") {
      axios({
        url: authURL,
        method: "POST",
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST',
        },
        data: {
          username,
          password,
        },
      })
        .then((response) => {
          if (response.data) {
            handleResponse(response.data);
          }
        })
        .catch((error) => alert(error));
    }
  };

  const handleResponse = (responseData) => {
    console.log("handle response...", responseData);
    if (responseData.isValid) {
      console.log("user is valid");
      setUser(responseData.userData);
      navigate(`/partners/${responseData.userData.path}`);
    }
  };

  return (
    <Main>
      <Section customClass="login">
        <InnerContainer customClass="login-modal">
          <h1>Login</h1>
          <form id="login" onSubmit={handleSubmit}>
            <input
              className="input"
              placeholder="Username"
              type="text"
              value={username}
              onChange={handleNameChange}
              required
            />
            <input
              className="input"
              placeholder="password"
              type="password"
              value={password}
              onChange={handlePasswordChange}
              required
            />
            <input className="button" type="submit" />
          </form>
        </InnerContainer>
      </Section>
    </Main>
  );
};

export default Login;
